import { QUERY_KEYS_SERVICE_AGREEMENTS } from 'api/query-keys';
import { serviceAgreementsService } from 'ogp/services';
import { SupplierWorkTarget } from 'ogp/services/service-agreements.schema';
import { useQuery } from 'react-query';

export const useGetSupplierWorkTargets = (enabled: boolean) => {
  return useQuery<SupplierWorkTarget[], Error>(
    QUERY_KEYS_SERVICE_AGREEMENTS.supplierWorkTargets(),
    async () => await serviceAgreementsService.getSupplierWorkTargets(),
    { enabled }
  );
};
